import { IS_PRODUCT_COPY, IS_PRODUCT_EDIT, PRODUCT_COPY, RESET_PRODUCT_COPY, QUESTION_COPY, IS_QUESTION_COPY, RESET_QUESTION_COPY } from '../../../actions/types';

const INITIAL_STATE = {
    isProductCopy: false,
    productCopy: {},
    isProductEdit: false,
    questionCopy: {},
    isQuestionCopy: false
}

export default (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case IS_PRODUCT_COPY:
            return {
                ...state,
                isProductCopy: action.payload
            }
        case PRODUCT_COPY:
            return {
                ...state,
                productCopy: action.payload
            }
        case IS_PRODUCT_EDIT: 
            return {
                ...state,
                isProductEdit: action.payload
            }
        case RESET_PRODUCT_COPY:
            return {
                ...state,
                isProductCopy: false,
                productCopy: {}
            }
        case QUESTION_COPY:
            return {
                ...state,
                questionCopy: action.payload
            }
        case IS_QUESTION_COPY:
            return {
                ...state,
                isQuestionCopy: action.payload
            }
        case RESET_QUESTION_COPY:
            return {
                ...state,
                isQuestionCopy: false,
                questionCopy: {}
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/restaurants/posmenu/ProductCopyReducer.js